module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27115",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7031",
      "conversations-error-reporting": "static-1.8295",
      "conversations-internal-pub-sub": "static-1.15380",
      "conversations-internal-schema": "static-1.12025",
      "conversations-message-history": "static-1.10716",
      "conversations-test-sdk": "static-1.9837",
      "conversations-visitor-experience-components": "static-1.20478",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4903",
      "hs-test-utils": "static-1.7364",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10892",
      "I18n": "static-7.1456",
      "jasmine-immutable": "static-1.2343",
      "jasmine-runner": "static-1.5790",
      "quartz": "static-1.6191",
      "react-dlb": "static-1.63",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3916",
      "viral-links-lib": "static-1.6287",
      "visitor-ui-component-library": "static-1.5533",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3948",
      "atom": "static-1.4521",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4170",
      "conversations-infrastructure": "static-1.8320",
      "conversations-prop-types": "static-1.6800",
      "conversations-visibility-tools": "static-1.5148",
      "conversations-visitor-message-history": "static-1.19215",
      "cssUtils": "static-1.605",
      "enviro": "static-4.328",
      "flux-actions": "static-1.287",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15985",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4754",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3755",
      "sanitize-text": "static-1.7529",
      "signup-constants": "static-1.17657",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.476",
      "usage-tracker": "static-1.6800",
      "usage-tracker-core": "static-1.6650",
      "usage-tracker-multi": "static-1.5214",
      "usage-tracker-public": "static-1.6611",
      "visitor-ui-component-library-icons": "static-1.5344",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2900",
      "moment": "static-3.26",
      "quartz-core": "static-1.5410",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4229",
      "foundations-components": "static-1.6894",
      "foundations-theming": "static-1.3718",
      "UIComponents": "static-3.7839",
      "cv-backend-services": "static-1.1353",
      "immutable-less": "static-1.3937",
      "conversations-skeleton-state": "static-1.6739",
      "crm-events-viz-core": "static-1.31319",
      "icons": "static-2.597",
      "react-input-autosize": "static-2.17",
      "tanstack-virtual": "static-1.15",
      "rpc-client-utils": "static-1.4072",
      "ui-images": "static-2.971",
      "permission-components": "static-1.4714",
      "react-virtualized": "static-2.82",
      "HeadJS": "static-2.625",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2475",
      "msw": "static-1.39",
      "testing-library": "static-1.135",
      "i18n-data": "static-1.208",
      "moment-timezone": "static-5.68",
      "jasmine": "static-4.3682",
      "quartz-core-utils": "static-1.3058",
      "signup-ui-url-generator": "static-2.7453",
      "HubStyle": "static-2.11200",
      "sassPrefix": "static-1.142",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5217",
      "bender-build-tools": "static-1.2538",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.702",
      "hub-http-shared-msw-handlers": "static-1.8501",
      "hubspotter-http": "static-1.4015",
      "hubspotter-http-shared-msw-handlers": "static-1.8499",
      "mobile-manifest-mixins": "static-1.397",
      "platform-navigation-bootstrap": "static-1.11892",
      "quick-fetch": "static-1.3400",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "hs-story-utils": "static-1.8742",
      "bend-plugin-foundations-components": "static-1.3163",
      "floating-ui": "static-1.41",
      "foundations-theming-specialty": "static-1.1434",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2201",
      "foundations-theming-base": "static-1.2703",
      "ts-schema": "static-1.3543",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1854",
      "content-assistance-lib": "static-1.7010",
      "crm-component-utils": "static-1.37494",
      "crm-display-components": "static-1.23244",
      "crm-fe-perf": "static-1.22334",
      "crm-links": "static-1.5570",
      "crm-message-bus": "static-1.41324",
      "crm-search-service-types": "static-1.644",
      "crm-source-interpretation-lib": "static-1.4670",
      "customer-data-communicator": "static-1.43867",
      "customer-data-email": "static-1.16972",
      "customer-data-filters-ui": "static-1.37582",
      "customer-data-objects": "static-1.7022",
      "customer-data-objects-ui-components": "static-1.12355",
      "customer-data-properties": "static-1.49617",
      "customer-data-rte": "static-1.31599",
      "customer-data-ui-utilities": "static-1.9148",
      "data-fetching-client": "static-1.9045",
      "draft-plugins": "static-2.20614",
      "file-manager-components": "static-1.21860",
      "FileManagerCore": "static-1.37359",
      "frontend-preferences-client": "static-1.7311",
      "hubspot-apollo-client": "static-1.4202",
      "hubspot-prosemirror": "static-1.16575",
      "object-comments-thread-lib": "static-1.9122",
      "reference-resolvers-lite": "static-1.7429",
      "ui-addon-upgrades": "static-9.17002",
      "universal-associations-select": "static-1.10309",
      "platform-infra-nav-components": "static-1.7125",
      "graphql": "static-1.67",
      "ai-components-ui-library": "static-1.7375",
      "superstore": "static-1.4090",
      "ui-addon-video-player": "static-1.8124",
      "ui-coaching-tips": "static-1.26811",
      "card-properties-lib": "static-1.42462",
      "crm-actions": "static-1.5583",
      "crm-cards-data": "static-1.410",
      "crm-cards-sdk": "static-1.41800",
      "customer-data-properties-shared-msw-handlers": "static-1.7828",
      "customer-data-property-utils": "static-1.7347",
      "customer-data-tracking": "static-1.6223",
      "framework-data-schema-resolvers": "static-1.6266",
      "usage-tracker-container": "static-1.6790",
      "framework-data-table": "static-2.10579",
      "location-customization-utils-lib": "static-1.7388",
      "calling-error-reporting": "static-1.30682",
      "calling-internal-common": "static-1.30676",
      "calling-usage-tracker": "static-1.5877",
      "crm_data": "static-4.90078",
      "crm_schema": "static-3.90117",
      "crm-legacy-global-containers": "static-1.23169",
      "customer-data-content": "static-1.26133",
      "draft-content-plugins": "static-1.26948",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.22936",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22635",
      "EmailSignatureEditor": "static-1.23177",
      "FileManagerLib": "static-1.37500",
      "hubspot-prosemirror-plugins": "static-1.16567",
      "integration-settings-components": "static-1.13550",
      "integrations-lib": "static-1.14297",
      "integrations-tracking-lib": "static-1.5025",
      "native-integrations-shared-strings": "static-1.7182",
      "nav-meta": "static-1.27880",
      "outreach-assistant-email-generation": "static-1.5064",
      "property-translator": "static-1.4741",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.35938",
      "react-colorpicker": "static-2.9631",
      "react-dnd-compat": "static-1.4043",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7548",
      "rich-text-lib": "static-1.18752",
      "sales-email-signature-service-client": "static-1.3298",
      "sequences-lib": "static-1.7142",
      "timezone-utils": "static-2.4571",
      "ui-addon-i18n": "static-1.10367",
      "ui-addon-iframeable": "static-1.8297",
      "ui-business-units-lib": "static-1.8304",
      "ui-gdpr-components": "static-1.9608",
      "ui-shepherd-react": "static-3.9442",
      "user-context": "static-1.4562",
      "whatsapp-sending-lib": "static-1.3841",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4100",
      "salesImages": "static-1.512",
      "customer-data-filters-ui-msw-helpers": "static-1.20016",
      "customer-data-reference-ui-components": "static-1.12448",
      "FormUrlGenerator": "static-2.4079",
      "framework-builder-read-service-client": "static-1.3487",
      "framework-data-schema-quick-fetch": "static-1.6171",
      "inbound-db-meta-service-client": "static-1.3150",
      "inbound-db-properties-service-client": "static-1.3371",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.389",
      "onboarding-tours": "static-1.15801",
      "SharedI18nStrings": "static-1.171",
      "ui-addon-teams": "static-1.20731",
      "calling-cross-tab-library": "static-1.18669",
      "calling-global-api": "static-1.62423",
      "calling-integration-cross-tab": "static-1.21475",
      "calling-lifecycle-internal": "static-1.63805",
      "calling-lifecycle-messages": "static-1.56099",
      "commerce-products-lib": "static-1.7727",
      "conditional-properties-service-client": "static-1.3331",
      "external-options-client-types": "static-1.3539",
      "google-libphonenumber": "static-1.22",
      "inbounddb-objects-service-types": "static-1.3641",
      "object-builder-ui-client": "static-1.46760",
      "pipeline-validation-client-types": "static-1.3336",
      "property-value-citations": "static-1.231",
      "smart-property-lib": "static-1.4561",
      "tiered-pricing": "static-1.289",
      "ui-addon-form-validation": "static-1.10401",
      "directed-graph": "static-1.307",
      "event-emitter": "static-1.370",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3484",
      "video-components-external": "static-1.9504",
      "video-data-lib": "static-1.33162",
      "audio-components": "static-1.5154",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35011",
      "video-components": "static-1.11507",
      "video-embed": "static-1.33996",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23633",
      "knowledge-content-types": "static-1.8048",
      "payment-link-components": "static-1.21976",
      "ui-addon-emoji-picker": "static-1.9306",
      "call-summary": "static-1.37114",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8647",
      "batch-promise": "static-1.967",
      "feature-store-service-types": "static-1.4021",
      "growth-monetization-service-types": "static-1.4028",
      "merchandise-lib": "static-1.239",
      "self-service-api": "static-1.9627",
      "upgrade-management-service-types": "static-1.4012",
      "chatspot-client-types": "static-1.10069",
      "chatspot-core": "static-1.19012",
      "ContentUtils": "static-1.66464",
      "copilot-toolkit": "static-1.9518",
      "growth-onboarding-feedback-components": "static-1.5873",
      "customer-data-sidebar": "static-2.44381",
      "enrichment-properties-lib": "static-1.13679",
      "persist-promise": "static-1.3125",
      "crm-pipelines-api-client-types": "static-1.3515",
      "customer-data-associations": "static-1.6606",
      "reporting-data": "static-1.65040",
      "ui-addon-draggable": "static-3.4231",
      "crm-record-cards-service-types": "static-1.3108",
      "crm_universal": "static-1.21189",
      "SalesContentIndexUI": "static-3.8193",
      "signup-ui-lego-core": "static-1.19667",
      "content-embed-lib": "static-1.6721",
      "data-model-builder-lib": "static-1.10341",
      "remote-ui": "static-1.52",
      "ui-components-test-utils": "static-1.5030",
      "ui-extensions-remote-renderer": "static-1.15507",
      "universal-page-editor-lib": "static-1.2425",
      "integrations-error-boundary-lib": "static-1.11712",
      "laboratory-lib": "static-3.6561",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9838",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8243",
      "messaging-types-lib": "static-1.44114",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15405",
      "sequences-client-types-lib": "static-1.6999",
      "foundations-components-test-utils": "static-1.4378",
      "magpie-lib": "static-1.5022",
      "navigation-messaging": "static-1.5570",
      "getting-started-shared-tasks": "static-1.16818",
      "getting-started-shared-tasks-store": "static-1.15936",
      "whatsapp-management-lib": "static-1.7000",
      "growth-data-modal": "static-1.4686",
      "growth-onboarding-confetti": "static-1.2449",
      "growth-onboarding-next-action-utils": "static-1.805",
      "navigation-components": "static-1.16243",
      "ui-shepherd-tracker": "static-1.6823",
      "shared-worker-versioning": "static-1.10447",
      "worker-connection-library": "static-1.15954",
      "calling-orchestration-shared-library": "static-1.33638",
      "onboarding-scopes": "static-1.5888",
      "products-iframe-lib": "static-1.6337",
      "products-ui-components-shared-msw-handlers": "static-1.8883",
      "breeze-intelligence-kit": "static-1.4725",
      "fsm": "static-1.3073",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8584",
      "policy-lib": "static-1.6133",
      "react-tinymce": "static-1.53552",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52678",
      "tinymce-plugins": "static-1.55792",
      "tinymce-themes": "static-1.54648",
      "content-media-composition-data-lib": "static-1.9768",
      "content-media-compositions": "static-2.13775",
      "idb-keyval": "static-1.29",
      "magpie-types": "static-1.4482",
      "media-bridge-lib": "static-1.17986",
      "content-icons-ui": "static-1.2020",
      "social-insights-client-types": "static-1.20370",
      "outpost": "static-1.3688",
      "commerce-analytics-service-client": "static-1.3029",
      "ui-addon-opt": "static-4.7870",
      "commerce-tours-lib": "static-1.5116",
      "growth-onboarding-reliability": "static-1.4497",
      "sales-checkout-service-client": "static-1.3041",
      "ai-addon-copilot-preview": "static-1.6587",
      "wootric-nps": "static-1.6217",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4126",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2365",
      "card-payment-highlight-lib": "static-1.35502",
      "card-subscription-highlight-lib": "static-1.37818",
      "commerce-billing-lib": "static-1.17461",
      "commerce-contract-lib": "static-1.10002",
      "crm_components": "static-3.90078",
      "invoices-highlight-card-lib": "static-1.52835",
      "orders-highlight-card-lib": "static-1.20039",
      "products-highlight-card-lib": "static-1.16011",
      "project-storage": "static-1.4063",
      "quotes-highlight-card-lib": "static-1.69853",
      "usage-based-billing-components-lib": "static-1.7085",
      "reporting-client-types": "static-1.2261",
      "react-flip-move": "static-1.55",
      "FireAlarmUi": "static-1.4040",
      "sales-templates-service-types-lib": "static-1.3601",
      "ui-asset-management-lib": "static-1.10095",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8601",
      "collaboration-sidebar": "static-1.56213",
      "data-model-commons-lib": "static-1.10944",
      "feedback-loader": "static-1.28064",
      "final-form": "static-1.53",
      "html-to-image": "static-1.38",
      "object-definition-builder-lib": "static-1.6357",
      "property-management-iframe": "static-1.11024",
      "reactflow": "static-1.45",
      "used-in-list-lib": "static-1.6212",
      "visual-association": "static-1.5175",
      "highcharts": "static-8.89",
      "reporting-visualizations": "static-1.57117",
      "ui-extensibility-client-types": "static-1.3412",
      "automation-platform-service-types": "static-1.2331",
      "ContentData": "static-1.66539",
      "email-portal-health-service-types": "static-1.395",
      "marketing-email-service-types": "static-1.1623",
      "reactive-lib": "static-1.114",
      "purchase-motions-components": "static-1.4847",
      "short-messages-app-service-client": "static-1.3411",
      "ui-tool-access": "static-1.9455",
      "calling-orchestration-schema": "static-1.33863",
      "multi-currency-client-types": "static-1.3152",
      "sales-views-client-types": "static-1.3631",
      "trellis-story-utils": "static-1.3919",
      "storybook-react": "static-1.16",
      "hub-http-contrib": "static-1.2474",
      "interframe": "static-3.4135",
      "tinymce-data": "static-1.38763",
      "ui-addon-sales-email": "static-1.4578",
      "codemirror": "static-5.80",
      "layout-dnd-components": "static-1.11386",
      "layout-dnd-utils": "static-1.10361",
      "react-codemirror": "static-1.9983",
      "ui-brand-identity-lib": "static-1.12311",
      "NamespacedHubStyle": "static-2.8622",
      "hls.js": "static-1.24",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.4015",
      "ai-rendering-library": "static-1.8187",
      "ai-settings-ui-library": "static-1.6755",
      "chirp-fetch": "static-1.1364",
      "copilot-plugins": "static-1.9491",
      "commerce-shared-components-lib": "static-1.16938",
      "commerce-subscription-lib": "static-1.35395",
      "commerce-tools-ui-lib": "static-1.8969",
      "usage-tracker-session-replay": "static-1.4486",
      "utility-belt": "static-1.1869",
      "payments-enrollment-embed-lib": "static-1.20738",
      "quotes-ui-lib": "static-1.78569",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6044",
      "invoices-ui-lib": "static-1.52851",
      "commerce-products-api": "static-1.1326",
      "SafeStorage": "static-1.3751",
      "invoices-iframe-lib": "static-1.54909",
      "quotes-modal-lib": "static-1.100526",
      "reporting-ui-components": "static-2.62314",
      "subscription-experience-data-types": "static-1.13915",
      "association-translator": "static-1.2527",
      "crm-settings-header-lib": "static-1.7582",
      "settings-ui-nav": "static-2.9520",
      "chatspot-widget-iframe": "static-1.19004",
      "collaboration-sidebar-common": "static-1.1009",
      "property-management-common": "static-1.3311",
      "d3": "static-1.7",
      "crm-object-map": "static-1.4364",
      "advanced-menus-core": "static-1.14225",
      "advanced-menus-lib": "static-1.11279",
      "ExportDialog": "static-6.9846",
      "ui-memberships-settings-lib": "static-1.32240",
      "nav-client-types": "static-1.1637",
      "purchase-motions-api": "static-1.4849",
      "trials-service-types": "static-1.3429",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8686",
      "browser-eslint": "static-2.57",
      "highlight.js": "static-1.64",
      "reporting-action-components": "static-1.39677",
      "ui-addon-react-router-dom": "static-1.8974",
      "growth-onboarding-empty-states": "static-1.4899",
      "InboxConnectUtils": "static-4.13282",
      "payments-post-enroll-local-storage-lib": "static-1.4443",
      "qrcode-generator": "static-1.52",
      "amplitude-session-replay-browser": "static-1.45",
      "marketplace-ui-apps-core": "static-1.16441",
      "stripe-embedded-components": "static-1.6534",
      "products-ui-components": "static-1.38246",
      "totals-ui-components": "static-1.21987",
      "reporting-plugins": "static-1.9360",
      "reporting-reports": "static-1.64720",
      "reporting-snowflake": "static-1.53660",
      "crm-index-ui-shimmer": "static-1.107",
      "crm-index-visualization-object-layout": "static-1.4045",
      "crm-object-search-query-utilities": "static-1.8316",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14224",
      "simple-menus-lib": "static-1.15741",
      "eligibility-engine-service-types": "static-1.2710",
      "dashboard-lib": "static-1.79234",
      "share-with-third-party-component-lib": "static-1.8079",
      "developer-experience-shared-components": "static-1.9728",
      "marketplace-ui-client-types": "static-1.15314",
      "marketplace-ui-common": "static-1.17907",
      "ui-addon-integrations-directory-panel": "static-2.7429",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3193",
      "commerce-totals-service-types": "static-1.3279",
      "campaign-roi-lib": "static-1.7142",
      "reporting-datasets-permissions-lib": "static-1.11832",
      "hs-entities": "static-1.19",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3355",
      "oauth-service-types": "static-1.3619",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27115",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7031",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8295",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15380",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12025",
      "conversations-message-history": "/conversations-message-history/static-1.10716",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9837",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20478",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4903",
      "hs-test-utils": "/hs-test-utils/static-1.7364",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10892",
      "I18n": "/I18n/static-7.1456",
      "jasmine-immutable": "/jasmine-immutable/static-1.2343",
      "jasmine-runner": "/jasmine-runner/static-1.5790",
      "quartz": "/quartz/static-1.6191",
      "react-dlb": "/react-dlb/static-1.63",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3916",
      "viral-links-lib": "/viral-links-lib/static-1.6287",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5533",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3948",
      "atom": "/atom/static-1.4521",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4170",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8320",
      "conversations-prop-types": "/conversations-prop-types/static-1.6800",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5148",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19215",
      "cssUtils": "/cssUtils/static-1.605",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.287",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15985",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4754",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3755",
      "sanitize-text": "/sanitize-text/static-1.7529",
      "signup-constants": "/signup-constants/static-1.17657",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "usage-tracker": "/usage-tracker/static-1.6800",
      "usage-tracker-core": "/usage-tracker-core/static-1.6650",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5214",
      "usage-tracker-public": "/usage-tracker-public/static-1.6611",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5344",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2900",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5410",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4229",
      "foundations-components": "/foundations-components/static-1.6894",
      "foundations-theming": "/foundations-theming/static-1.3718",
      "UIComponents": "/UIComponents/static-3.7839",
      "cv-backend-services": "/cv-backend-services/static-1.1353",
      "immutable-less": "/immutable-less/static-1.3937",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6739",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31319",
      "icons": "/icons/static-2.597",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.15",
      "rpc-client-utils": "/rpc-client-utils/static-1.4072",
      "ui-images": "/ui-images/static-2.971",
      "permission-components": "/permission-components/static-1.4714",
      "react-virtualized": "/react-virtualized/static-2.82",
      "HeadJS": "/HeadJS/static-2.625",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2475",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.135",
      "i18n-data": "/i18n-data/static-1.208",
      "moment-timezone": "/moment-timezone/static-5.68",
      "jasmine": "/jasmine/static-4.3682",
      "quartz-core-utils": "/quartz-core-utils/static-1.3058",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7453",
      "HubStyle": "/HubStyle/static-2.11200",
      "sassPrefix": "/sassPrefix/static-1.142",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5217",
      "bender-build-tools": "/bender-build-tools/static-1.2538",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.702",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8501",
      "hubspotter-http": "/hubspotter-http/static-1.4015",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8499",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.397",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11892",
      "quick-fetch": "/quick-fetch/static-1.3400",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "hs-story-utils": "/hs-story-utils/static-1.8742",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3163",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1434",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2201",
      "foundations-theming-base": "/foundations-theming-base/static-1.2703",
      "ts-schema": "/ts-schema/static-1.3543",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1854",
      "content-assistance-lib": "/content-assistance-lib/static-1.7010",
      "crm-component-utils": "/crm-component-utils/static-1.37494",
      "crm-display-components": "/crm-display-components/static-1.23244",
      "crm-fe-perf": "/crm-fe-perf/static-1.22334",
      "crm-links": "/crm-links/static-1.5570",
      "crm-message-bus": "/crm-message-bus/static-1.41324",
      "crm-search-service-types": "/crm-search-service-types/static-1.644",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4670",
      "customer-data-communicator": "/customer-data-communicator/static-1.43867",
      "customer-data-email": "/customer-data-email/static-1.16972",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37582",
      "customer-data-objects": "/customer-data-objects/static-1.7022",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12355",
      "customer-data-properties": "/customer-data-properties/static-1.49617",
      "customer-data-rte": "/customer-data-rte/static-1.31599",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9148",
      "data-fetching-client": "/data-fetching-client/static-1.9045",
      "draft-plugins": "/draft-plugins/static-2.20614",
      "file-manager-components": "/file-manager-components/static-1.21860",
      "FileManagerCore": "/FileManagerCore/static-1.37359",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7311",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4202",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16575",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9122",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7429",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17002",
      "universal-associations-select": "/universal-associations-select/static-1.10309",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7125",
      "graphql": "/graphql/static-1.67",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7375",
      "superstore": "/superstore/static-1.4090",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8124",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26811",
      "card-properties-lib": "/card-properties-lib/static-1.42462",
      "crm-actions": "/crm-actions/static-1.5583",
      "crm-cards-data": "/crm-cards-data/static-1.410",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41800",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7828",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7347",
      "customer-data-tracking": "/customer-data-tracking/static-1.6223",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6266",
      "usage-tracker-container": "/usage-tracker-container/static-1.6790",
      "framework-data-table": "/framework-data-table/static-2.10579",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7388",
      "calling-error-reporting": "/calling-error-reporting/static-1.30682",
      "calling-internal-common": "/calling-internal-common/static-1.30676",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5877",
      "crm_data": "/crm_data/static-4.90078",
      "crm_schema": "/crm_schema/static-3.90117",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23169",
      "customer-data-content": "/customer-data-content/static-1.26133",
      "draft-content-plugins": "/draft-content-plugins/static-1.26948",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.22936",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22635",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23177",
      "FileManagerLib": "/FileManagerLib/static-1.37500",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16567",
      "integration-settings-components": "/integration-settings-components/static-1.13550",
      "integrations-lib": "/integrations-lib/static-1.14297",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5025",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7182",
      "nav-meta": "/nav-meta/static-1.27880",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5064",
      "property-translator": "/property-translator/static-1.4741",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.35938",
      "react-colorpicker": "/react-colorpicker/static-2.9631",
      "react-dnd-compat": "/react-dnd-compat/static-1.4043",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7548",
      "rich-text-lib": "/rich-text-lib/static-1.18752",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3298",
      "sequences-lib": "/sequences-lib/static-1.7142",
      "timezone-utils": "/timezone-utils/static-2.4571",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10367",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8297",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8304",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9608",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9442",
      "user-context": "/user-context/static-1.4562",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.3841",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4100",
      "salesImages": "/salesImages/static-1.512",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20016",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12448",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4079",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3487",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6171",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3150",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3371",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.389",
      "onboarding-tours": "/onboarding-tours/static-1.15801",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "ui-addon-teams": "/ui-addon-teams/static-1.20731",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18669",
      "calling-global-api": "/calling-global-api/static-1.62423",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21475",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63805",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56099",
      "commerce-products-lib": "/commerce-products-lib/static-1.7727",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3331",
      "external-options-client-types": "/external-options-client-types/static-1.3539",
      "google-libphonenumber": "/google-libphonenumber/static-1.22",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3641",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46760",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3336",
      "property-value-citations": "/property-value-citations/static-1.231",
      "smart-property-lib": "/smart-property-lib/static-1.4561",
      "tiered-pricing": "/tiered-pricing/static-1.289",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10401",
      "directed-graph": "/directed-graph/static-1.307",
      "event-emitter": "/event-emitter/static-1.370",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3484",
      "video-components-external": "/video-components-external/static-1.9504",
      "video-data-lib": "/video-data-lib/static-1.33162",
      "audio-components": "/audio-components/static-1.5154",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35011",
      "video-components": "/video-components/static-1.11507",
      "video-embed": "/video-embed/static-1.33996",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23633",
      "knowledge-content-types": "/knowledge-content-types/static-1.8048",
      "payment-link-components": "/payment-link-components/static-1.21976",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9306",
      "call-summary": "/call-summary/static-1.37114",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8647",
      "batch-promise": "/batch-promise/static-1.967",
      "feature-store-service-types": "/feature-store-service-types/static-1.4021",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4028",
      "merchandise-lib": "/merchandise-lib/static-1.239",
      "self-service-api": "/self-service-api/static-1.9627",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4012",
      "chatspot-client-types": "/chatspot-client-types/static-1.10069",
      "chatspot-core": "/chatspot-core/static-1.19012",
      "ContentUtils": "/ContentUtils/static-1.66464",
      "copilot-toolkit": "/copilot-toolkit/static-1.9518",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5873",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44381",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13679",
      "persist-promise": "/persist-promise/static-1.3125",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3515",
      "customer-data-associations": "/customer-data-associations/static-1.6606",
      "reporting-data": "/reporting-data/static-1.65040",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4231",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3108",
      "crm_universal": "/crm_universal/static-1.21189",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8193",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19667",
      "content-embed-lib": "/content-embed-lib/static-1.6721",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10341",
      "remote-ui": "/remote-ui/static-1.52",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5030",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15507",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2425",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11712",
      "laboratory-lib": "/laboratory-lib/static-3.6561",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9838",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8243",
      "messaging-types-lib": "/messaging-types-lib/static-1.44114",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15405",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6999",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4378",
      "magpie-lib": "/magpie-lib/static-1.5022",
      "navigation-messaging": "/navigation-messaging/static-1.5570",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16818",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15936",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7000",
      "growth-data-modal": "/growth-data-modal/static-1.4686",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2449",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.805",
      "navigation-components": "/navigation-components/static-1.16243",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6823",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10447",
      "worker-connection-library": "/worker-connection-library/static-1.15954",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33638",
      "onboarding-scopes": "/onboarding-scopes/static-1.5888",
      "products-iframe-lib": "/products-iframe-lib/static-1.6337",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8883",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4725",
      "fsm": "/fsm/static-1.3073",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8584",
      "policy-lib": "/policy-lib/static-1.6133",
      "react-tinymce": "/react-tinymce/static-1.53552",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52678",
      "tinymce-plugins": "/tinymce-plugins/static-1.55792",
      "tinymce-themes": "/tinymce-themes/static-1.54648",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9768",
      "content-media-compositions": "/content-media-compositions/static-2.13775",
      "idb-keyval": "/idb-keyval/static-1.29",
      "magpie-types": "/magpie-types/static-1.4482",
      "media-bridge-lib": "/media-bridge-lib/static-1.17986",
      "content-icons-ui": "/content-icons-ui/static-1.2020",
      "social-insights-client-types": "/social-insights-client-types/static-1.20370",
      "outpost": "/outpost/static-1.3688",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3029",
      "ui-addon-opt": "/ui-addon-opt/static-4.7870",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5116",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4497",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3041",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6587",
      "wootric-nps": "/wootric-nps/static-1.6217",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4126",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2365",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35502",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37818",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17461",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10002",
      "crm_components": "/crm_components/static-3.90078",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52835",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20039",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16011",
      "project-storage": "/project-storage/static-1.4063",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69853",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7085",
      "reporting-client-types": "/reporting-client-types/static-1.2261",
      "react-flip-move": "/react-flip-move/static-1.55",
      "FireAlarmUi": "/FireAlarmUi/static-1.4040",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3601",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10095",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8601",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56213",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.10944",
      "feedback-loader": "/feedback-loader/static-1.28064",
      "final-form": "/final-form/static-1.53",
      "html-to-image": "/html-to-image/static-1.38",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6357",
      "property-management-iframe": "/property-management-iframe/static-1.11024",
      "reactflow": "/reactflow/static-1.45",
      "used-in-list-lib": "/used-in-list-lib/static-1.6212",
      "visual-association": "/visual-association/static-1.5175",
      "highcharts": "/highcharts/static-8.89",
      "reporting-visualizations": "/reporting-visualizations/static-1.57117",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3412",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2331",
      "ContentData": "/ContentData/static-1.66539",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.395",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1623",
      "reactive-lib": "/reactive-lib/static-1.114",
      "purchase-motions-components": "/purchase-motions-components/static-1.4847",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3411",
      "ui-tool-access": "/ui-tool-access/static-1.9455",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33863",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3152",
      "sales-views-client-types": "/sales-views-client-types/static-1.3631",
      "trellis-story-utils": "/trellis-story-utils/static-1.3919",
      "storybook-react": "/storybook-react/static-1.16",
      "hub-http-contrib": "/hub-http-contrib/static-1.2474",
      "interframe": "/interframe/static-3.4135",
      "tinymce-data": "/tinymce-data/static-1.38763",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4578",
      "codemirror": "/codemirror/static-5.80",
      "layout-dnd-components": "/layout-dnd-components/static-1.11386",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10361",
      "react-codemirror": "/react-codemirror/static-1.9983",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12311",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8622",
      "hls.js": "/hls.js/static-1.24",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4015",
      "ai-rendering-library": "/ai-rendering-library/static-1.8187",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6755",
      "chirp-fetch": "/chirp-fetch/static-1.1364",
      "copilot-plugins": "/copilot-plugins/static-1.9491",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16938",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35395",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8969",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4486",
      "utility-belt": "/utility-belt/static-1.1869",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20738",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78569",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6044",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52851",
      "commerce-products-api": "/commerce-products-api/static-1.1326",
      "SafeStorage": "/SafeStorage/static-1.3751",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54909",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100526",
      "reporting-ui-components": "/reporting-ui-components/static-2.62314",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13915",
      "association-translator": "/association-translator/static-1.2527",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7582",
      "settings-ui-nav": "/settings-ui-nav/static-2.9520",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19004",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1009",
      "property-management-common": "/property-management-common/static-1.3311",
      "d3": "/d3/static-1.7",
      "crm-object-map": "/crm-object-map/static-1.4364",
      "advanced-menus-core": "/advanced-menus-core/static-1.14225",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11279",
      "ExportDialog": "/ExportDialog/static-6.9846",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32240",
      "nav-client-types": "/nav-client-types/static-1.1637",
      "purchase-motions-api": "/purchase-motions-api/static-1.4849",
      "trials-service-types": "/trials-service-types/static-1.3429",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8686",
      "browser-eslint": "/browser-eslint/static-2.57",
      "highlight.js": "/highlight.js/static-1.64",
      "reporting-action-components": "/reporting-action-components/static-1.39677",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8974",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4899",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13282",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4443",
      "qrcode-generator": "/qrcode-generator/static-1.52",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16441",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6534",
      "products-ui-components": "/products-ui-components/static-1.38246",
      "totals-ui-components": "/totals-ui-components/static-1.21987",
      "reporting-plugins": "/reporting-plugins/static-1.9360",
      "reporting-reports": "/reporting-reports/static-1.64720",
      "reporting-snowflake": "/reporting-snowflake/static-1.53660",
      "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.107",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.4045",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8316",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14224",
      "simple-menus-lib": "/simple-menus-lib/static-1.15741",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2710",
      "dashboard-lib": "/dashboard-lib/static-1.79234",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8079",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9728",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15314",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17907",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7429",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3193",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3279",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7142",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11832",
      "hs-entities": "/hs-entities/static-1.19",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3355",
      "oauth-service-types": "/oauth-service-types/static-1.3619",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};